import { model as routerModel } from '!/router'
import { F, T, exists, nay } from '@/helpers'
import { decodeImg } from '@/tools'
import { createEffect, createEvent, createStore, sample } from 'effector'
import { runtime } from '~/app'
import { model as sessionModel } from '~/entities/session'

export const DEFAULT_AUTH_BACKGROUND_URL = '/img/auth-background.jpg'

export const loadBackgroundFx = createEffect<string, void, void>(decodeImg)

export const $authBackgroundUrl = createStore<string>('')

export const $backgroundLoaded = createStore<boolean>(false).on(
  loadBackgroundFx.finally,
  T
)

export const loadBackground = createEvent()

sample({
  clock: loadBackground,
  source: { loading: loadBackgroundFx.pending, loaded: $backgroundLoaded },
  filter: ({ loading, loaded }) => nay(loading) && nay(loaded),
  fn: () => (runtime.assets.authBackgroundUrl ?? '') as string,
  target: loadBackgroundFx,
})

// reset opacity on any `isAuthenticated` flag changes (except some routes)
sample({
  clock: sessionModel.$authenticated,
  source: routerModel.$pathname,
  filter: (pathname) =>
    exists(pathname) &&
    !pathname.startsWith('/toa') &&
    !pathname.startsWith('/sign-in') &&
    !pathname.startsWith('/sign-up') &&
    !pathname.startsWith('/geoblock') &&
    !pathname.startsWith('/forgot-password'),
  fn: F,
  target: $backgroundLoaded,
})

sample({
  clock: loadBackgroundFx.done,
  fn: ({ params }) => params,
  target: $authBackgroundUrl,
})

sample({
  clock: loadBackgroundFx.fail,
  fn: () => DEFAULT_AUTH_BACKGROUND_URL,
  target: $authBackgroundUrl,
})
